// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foot[data-v-ab5198e4]{position:fixed;bottom:0;left:0;height:60px;flex-direction:column;align-items:center;color:#fff;background-color:#fff;font-size:14px;z-index:21}.foot[data-v-ab5198e4],.foot .btn-wrap[data-v-ab5198e4]{width:100%;display:flex;justify-content:center}.foot audio[data-v-ab5198e4]{height:30px;margin-left:10px}.mainBackground[data-v-ab5198e4]{color:#fff;background:#4f585f!important}", ""]);
// Exports
module.exports = exports;
